import React from "react";
import IconToggle from "../UI/Header/IconToggle";
import { useSelector } from "react-redux";
import Profile from "../UI/Header/Profie";
import NotificationBell from "../UI/Notifications/NotificationBell";

const Head = ({ toggleTheme, thememode }) => {
  const toggle = useSelector((state) => state.Sidebar.toggle);

  return (
    <nav
      className={`pr-[30px] flex items-center justify-between h-[4rem] duration-500 bg-secondary dark:bg-darkPrimary ${
        toggle
          ? "!justify-end md:!justify-between w-full md:pl-[285px]"
          : "pl-[30px]"
      }`}
    >
      <IconToggle />
      <div className="flex justify-between items-center z-30 gap-x-2">
        {/* Theme Toggle Button */}
        <button
          onClick={toggleTheme}
          className="p-2 rounded-full bg-secondary dark:bg-darkPrimary"
        >
          {thememode === "light" ? "🌙" : "☀️"}
        </button>
        {/* <Notification /> */}
        <Profile />
        <NotificationBell />
      </div>
    </nav>
  );
};

export default Head;
